import React, { useState, useEffect } from "react";

import styles from "./QuantityComponent.module.css";

const QuantityComponent = ({
  id,
  data,
  name,
  bandType,
  min,
  max,
  qty,
  handleQtyChange,
}) => {
  const [quantity, setQuantity] = useState(qty);

  // Sync internal state with qty prop when it changes
  useEffect(() => {
    setQuantity(qty);
  }, [qty]);

  const handleOnClick = (value) => {
    setQuantity(value);
    handleQtyChange(value, id, name, bandType, data);
  };

  return (
    <div className={styles["qty-comp"]}>
      <button
        onClick={() => handleOnClick(quantity - 1)}
        disabled={quantity === min}
        className={quantity > min ? styles["active"] : styles["inactive"]}
      >
        -
      </button>
      <div className={styles["qty-value"]}>{quantity}</div>
      <button
        onClick={() => handleOnClick(quantity + 1)}
        disabled={quantity === max}
        className={quantity < max ? styles["active"] : styles["inactive"]}
      >
        +
      </button>
    </div>
  );
};

export default QuantityComponent;
